import SCHCTemplates from './SCHCTemplates';

export const PAGE_SCHC_TEMPLATES = '/schc-templates';

export default SCHCTemplates;
